import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoadingSpinnerService } from './loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  displayLoading: boolean;

  constructor(
    private loadinService: LoadingSpinnerService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.init();
  }

  init() {
    this.loadinService.getLoadingObservable().subscribe((status) => {
      this.displayLoading = status === 'start';
      this.cdRef.detectChanges();
    });
  }

}
